import { lazy } from "react";
import MainLayout from "layout/MainLayout";
import Loadable from "ui-component/Loadable";
import PermissionGuard from "./PermissionGuard";

// Dashboard
const Dashboard = Loadable(lazy(() => import("views/dashboard/Default")));

// Profile
const EditProfile = Loadable(lazy(() => import("views/utilities/profile/edit-profile")));

// E-Paper
const EPaper = Loadable(lazy(() => import("views/utilities/e-paper")));
const AddEPaper = Loadable(lazy(() => import("views/utilities/e-paper/add-epaper")));
const EditEPaper = Loadable(lazy(() => import("views/utilities/e-paper/edit-epaper")));
const ViewPages = Loadable(lazy(() => import("views/utilities/e-paper/pages")));
const EditPage = Loadable(lazy(() => import("views/utilities/e-paper/pages/edit-pages")));

// Staff
const StaffList = Loadable(lazy(() => import("views/utilities/staff")));
const AddStaff = Loadable(lazy(() => import("views/utilities/staff/add-staff")));
const EditStaff = Loadable(lazy(() => import("views/utilities/staff/edit-staff")));

// Roles
const RoleList = Loadable(lazy(() => import("views/utilities/roles")));
const AddRole = Loadable(lazy(() => import("views/utilities/roles/add-role")));
const EditRole = Loadable(lazy(() => import("views/utilities/roles/edit-role")));

const MainRoutes = {
  path: "/",
  element: <MainLayout />,
  children: [
    { path: "/dashboard", element: <PermissionGuard permission="dashboard.view"><Dashboard /></PermissionGuard> },
    { path: "profile", element: <EditProfile /> },
    // E-Paper
    { path: "e-paper", element: <PermissionGuard permission="epaper.view"><EPaper /></PermissionGuard> },
    { path: "add-epaper", element: <PermissionGuard permission="epaper.create"><AddEPaper /></PermissionGuard> },
    { path: "edit-epaper/:id", element: <PermissionGuard permission="epaper.edit"><EditEPaper /></PermissionGuard> },
    { path: "view-epaper/pages/:id", element: <PermissionGuard permission="epaper.view"><ViewPages /></PermissionGuard> },
    { path: "edit-page/:id", element: <PermissionGuard permission="epaper.edit"><EditPage /></PermissionGuard> },
    // Staff
    { path: "staff", element: <PermissionGuard permission="staff.view"><StaffList /></PermissionGuard> },
    { path: "add-staff", element: <PermissionGuard permission="staff.create"><AddStaff /></PermissionGuard> },
    { path: "edit-staff/:id", element: <PermissionGuard permission="staff.edit"><EditStaff /></PermissionGuard> },
    // Roles
    { path: "roles", element: <PermissionGuard permission="roles.view"><RoleList /></PermissionGuard> },
    { path: "add-role", element: <PermissionGuard permission="roles.create"><AddRole /></PermissionGuard> },
    { path: "edit-role/:id", element: <PermissionGuard permission="roles.edit"><EditRole /></PermissionGuard> },
  ],
};

export default MainRoutes;
